import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import { subscribeShopify } from '@/service';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';

const { EFPic } = createEFPic('');
enum STEP {
    subscribe,
    congratulations,
}
const Icon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M27.6673 10L13.0007 24.6667L5.5 17.5" stroke="#3F68E0" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function A({ IS_ZA_SALE }: any) {
    const { useLang, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const [enter, setEnter] = useState(false);
    const [step, setStep] = useState(STEP.subscribe);
    const [email, setEmail] = useState('');
    const [errorEmail, setErrorEmail] = useState(false);

    const onSubmit = async () => {
        const data = {
            email: email,
            contactListId: '602439296',
            fields: [
                {
                    id: '8916',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
            ],
            eventTracking: subscribeCookie({
                sector_name: 'Subscribe now for exclusive benefits!',
                entry_position: 2,
            }),
        };
        const res = await subscribeShopify(data, locale);
        if (res?.code === '0') {
            setStep(STEP.congratulations);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('river2.details.sec1_email_btn'),
                status: 'success',
                tag: 'Agree',
            });
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('river2.details.sec1_email_btn'),
                status: 'fail',
                tag: 'Agree',
            });
        }
    };

    const onJoin = () => window.open('https://www.facebook.com/groups/efsouthafrica');

    useEffect(() => {
        let timer: any;
        if (!enter && typeof window !== 'undefined') {
            timer = setTimeout(() => {
                setEnter(true);
            }, 500);
        }
        return () => {
            timer = null;
            clearTimeout(timer);
        };
    }, []);

    return (
        <div className={`river2_details_A ${css.A_1}`}>
            <div className="innerBox">
                <div className="imgBox" style={IS_ZA_SALE ? { marginTop: 0 } : {}}>
                    <EFPic
                        name="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711702012639/river_2_pro_kv_768_za.png"
                        className="fullImgs"
                        alt={t('river2.details.sec1_title')}
                        aria-label={t('river2.details.sec1_title')}
                    />
                    {!IS_ZA_SALE && (
                        <div className="top-bar">
                            Sign up to get an additional R500 discount. Be the first to know when EcoFlow RIVER 2 Pro arrives on April 15th.
                        </div>
                    )}
                    <div className={`textBox ${enter ? 'enter' : ''}`} style={IS_ZA_SALE ? { top: '0.6rem' } : {}}>
                        {IS_ZA_SALE ? (
                            <>
                                <p className="sub-title">Double EcoCredits | April 15–29 Only</p>
                                <p className="title">EcoFlow RIVER 2 Pro</p>
                                <p className="desc">
                                    <span className="sub-desc">Discover the best portable power station under 1 kWh</span>
                                </p>
                            </>
                        ) : (
                            <>
                                <p className="sub-title">Double EcoCredits + R500 OFF Coupon | April 15–29 Only</p>
                                <p className="title">{t('river2.details.sec1_title')}</p>
                                <p className="desc">
                                    {t('river2.details.sec1_desc')}
                                    <span className="sub-desc">The Best Portable Power Station within Stage 6 Loadshedding</span>
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {!IS_ZA_SALE && (
                <div className="email-wrapper">
                    <EFPic
                        name="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711702002625/r2p_email_768_za.png"
                        alt={t('river2.details.sec1_title')}
                        aria-label={t('river2.details.sec1_title')}
                    />
                    <div className="bottom">
                        <div className={`subscribe ${step === STEP.subscribe ? 'show' : ''}`}>
                            <div className="title">
                                {t.rich('river2.details.sec1_email_title', {
                                    color: (text: string) => <span className="color">{text} </span>,
                                    sub: (text: string) => <p className="sub">{text} </p>,
                                    desc: (text: string) => <p className="desc">{text} </p>,
                                })}
                            </div>
                            <input
                                className={`email-input ${errorEmail ? 'error' : ''}`}
                                type="text"
                                placeholder={t('river2.details.sec1_email_placeholder')}
                                value={email}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    const regx =
                                        /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                                    if (value && !regx.test(value)) {
                                        setErrorEmail(true);
                                    } else {
                                        setErrorEmail(false);
                                    }
                                    setEmail(value.trim());
                                }}
                            />
                            <button onClick={onSubmit} disabled={!email && errorEmail}>
                                {t('river2.details.sec1_email_btn')}
                            </button>
                            <div className="tips">
                                <input type="checkbox" />
                                <p>
                                    {t.rich('river2.details.sec1_email_tips', {
                                        link1: (child: string) => (
                                            <Link className="link" href="https://za.ecoflow.com/policies/privacy-policy">
                                                {child}
                                            </Link>
                                        ),
                                        link2: (child: string) => (
                                            <Link className="link" href="https://za.ecoflow.com/policies/terms-of-service">
                                                {child}
                                            </Link>
                                        ),
                                    })}
                                </p>
                            </div>
                        </div>
                        <div className={`congratulations ${step === STEP.congratulations ? 'show' : ''}`}>
                            <div className="icon">
                                <Icon />
                            </div>
                            <p className="title">{t('river2.details.sec1_congratulations_title')}</p>
                            <p className="desc">{t('river2.details.sec1_congratulations_desc')}</p>
                            <button onClick={onJoin}>{t('river2.details.sec1_congratulations_btn')}</button>
                        </div>
                    </div>
                </div>
            )}
            <style jsx global>
                {`
                    .detail-nav {
                        .right {
                            .btn-link {
                                display: ${locale === '' ? 'none' : 'block'};
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
}
